import { GooglePayment } from 'braintree-web';

export enum GooglePayScriptStatus {
    init = 'init',
    loading = 'loading',
    loaded = 'loaded',
    failed = 'failed',
}

export interface GooglePayNamespace {
    canMakePaymentsWithGooglePay: boolean | null;
    googlePayInstance: GooglePayment | null;
    googlePayPaymentRequest: google.payments.api.PaymentDataRequest | null;
    googlePayScriptStatus: GooglePayScriptStatus;
    hasError: boolean;
    isLoadingGooglePay: boolean;
}

export interface WithGooglePayNamespace {
    googlePay: GooglePayNamespace;
}
